import { BuildHtml } from "~/components/BuildHtml";
import { isPopulatedString } from "~/lib/shared/isPopulatedString";
import { IconButton } from "~/ui-library";
import { ArrowDownTrayIcon } from "~/ui-library/icons";
import { useDocument } from "~/lib/client/useDocument";
import { downloadChart, generateChartFilename } from "./downloadChart";

type FooterProps = {
  footnote?: string;
  methodology?: string;
  chartIconContainer: React.ReactNode;
  chartContentRef?: React.RefObject<HTMLDivElement>;
  unformattedFilename?: string;
};

export const EvervizChartFooter = ({
  footnote,
  methodology,
  chartIconContainer,
  chartContentRef,
  unformattedFilename,
}: FooterProps) => {
  const document = useDocument();

  const handleDownloadChart = async () => {
    const filename = generateChartFilename(unformattedFilename);
    if (chartContentRef?.current && document) {
      await downloadChart({
        element: chartContentRef.current,
        document,
        filename,
      });
    }
  };

  return (
    <>
      <div className="mt-m flex flex-row flex-wrap-reverse place-items-end justify-between border-b-1 border-solid border-gray-300 pb-xs text-gray-700">
        <>
          <div className="flex w-full flex-auto items-center justify-between space-x-xs overflow-hidden">
            <div className="max-w-[300px] flex-1">{chartIconContainer}</div>
            {chartContentRef?.current && (
              <div data-html2canvas-ignore>
                <IconButton
                  aria-label="Download chart as PNG"
                  SvgIcon={ArrowDownTrayIcon}
                  onClick={handleDownloadChart}
                  size="default"
                  variant="subtle"
                />
              </div>
            )}
          </div>
          {isPopulatedString(footnote) && (
            <div className="flex w-1/2 flex-auto justify-end pb-xs text-right text-body-xsmall text-gray-700 md:pb-0">
              <span>{footnote}</span>
            </div>
          )}
        </>
      </div>
      {isPopulatedString(methodology) && (
        <div className="pt-xs text-body-xsmall text-gray-700">
          <BuildHtml html={methodology} />
        </div>
      )}
    </>
  );
};
